export const isOnApp = (): boolean => {
  return Boolean(
    navigator.userAgent.match('Boitata-App') ||
      document.cookie.match('is_on_mobile_app=true') ||
      window.location.search.match('isOnMobileApp=true')
  )
}
